import { useLayoutEffect } from "react";
import { controller } from "./runtime";
import { safely } from "./contracts";

/** Each visible UI loader is a balanced source; SDK merges overlapping intervals. */
export function useTelemetryLoader(visible = true) {
  useLayoutEffect(
    () =>
      visible ? safely(() => controller.acquireLoader(), undefined) : undefined,
    [visible]
  );
}
